import classNames from "classnames/bind";
import { ResolvedStaticCardList } from "resolvers/data/staticCardListResolver";
import { checkRichTextIsNotEmpty } from "utils/checkRichTextIsNotEmpty";

import RichText from "../RichText";
import StaticCard from "./StaticCard";
import styles from "./StaticCardList.module.scss";

const cx = classNames.bind(styles);

const StaticCardList = (props: ResolvedStaticCardList) => {
    return (
        <div className={cx("staticCardListContainer")}>
            {(!!props.sectionHeading || !!props.copy) && (
                <div className={cx("headingAndCopy")}>
                    {!!props.sectionHeading && (
                        <h2 className={cx("heading")}>{props.sectionHeading}</h2>
                    )}
                    {!!props.copy && <span className={cx("copy")}>{props.copy}</span>}
                </div>
            )}
            <div className={cx("staticCards")}>
                {props.cards.map((card, index) => {
                    return <StaticCard {...card} key={index} />;
                })}
            </div>
            {!!props.caveatText && checkRichTextIsNotEmpty(props.caveatText?.html) && (
                <RichText className={cx("caveat")} {...props.caveatText} />
            )}
        </div>
    );
};

export default StaticCardList;
